export default __webpack_public_path__ + "static/media/FEBDOM2025.4178961c.png";